import template from './template.html';
import controller from './controller';

const controllerAs = 'marketplaceAdminRegCtrl';

const bindings = {
  buttonStyle: '<',
  text: '<',
  courseId: '<',
  eventId: '<',
  eventOrCourse: '<',
  location: '<',
  locationOverride: '<',
  registrationCallback: '&',
  successCallback: '&',
  successCallbackParams: '<',
  profileUid: '<',
  template: '<',
  deliveryLocation: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/marketplaceAdminReg/index.js